export default __webpack_public_path__ + "icons/resizer-28920c.svg";